<template>
  <div class="flex flex-col items-center even:bg-gray-100" v-if="project">
    <div class="w-full border-b border-gray-200">
      <div class="flex flex-wrap items-center align-middle p-1 text-gray-700">
        <div class="flex items-center w-8" v-if="!rendering">
          <div class="text-left">
            <span class="mr-1 text-sm pb-1" v-text="project.rank"></span>
          </div>
        </div>

        <div
          class="w-1/2 text-left pl-2 flex items-center whitespace-no-wrap text-sm flex-grow"
        >
          <img
            :src="project.icons.application"
            alt="application"
            class="w-5 h-5 mr-1"
          />
          {{ project.label }}
        </div>

        <progress-bar
          v-if="rendering && percent !== null"
          :progress="percent"
        ></progress-bar>

        <div
          v-if="project.priority && project.priority.name"
          class="flex items-center justify-end text-sm whitespace-no-wrap flex-shrink-0"
          :style="rendering ? 'width:19.25rem' : ''"
        >
          <span class="pr-2">{{ project.priority.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBar from "../../Design/ProgressBar";

export default {
  props: ["project", "rendering"],
  components: { ProgressBar },
  computed: {
    percent() {
      return (
        this.project.qstatus &&
        this.project.qstatus.percent &&
        Math.round(this.project.qstatus.percent)
      );
    },
  },
};
</script>
